const Enum = Object.freeze

// these are category_ids of the associate modifiers
const PAYMENT_TYPES = Enum({
  DEPOSIT: 6,
  PAYMENT: 3,
  DISCOUNT: 4
})

// unclassified now to allow for more granularity in the future.
const ITEM_TYPES = Enum({
  UNCLASSIFIED: 7,
  ACCOMMODATIONS: 5
})

const MODIFIER_TYPES = Enum ({
  TAX: 1,
  FEE: 2
})

const ADJUSTMENT_TYPES = Enum ({
  GRATUITY: 8,
  REFUND: 9,
  DISCOUNT: 4
})

const PAYMENT_METHODS = Enum({
  MANUAL: 1,
  STRIPE: 2,
  TERMINAL: 3,
  CARD_READER: 4,
  IOS_TERMINAL: 5,
  OTHER: 6,
})

const MODIFIER_RATE_TYPES = Enum({
  FIXED: 1,
  PERCENTAGE: 2
})

const RESERVATION_RATE_TYPES = Enum({
  STANDARD: 1,
  FIXED: 2,
  NIGHTLY: 6
})

const UPDATE_TYPE = Enum({
  ITEM: 1,
  MODIFIER: 2
})

export {
  PAYMENT_TYPES,
  ITEM_TYPES,
  MODIFIER_TYPES,
  MODIFIER_RATE_TYPES,
  PAYMENT_METHODS,
  RESERVATION_RATE_TYPES,
  ADJUSTMENT_TYPES,
  UPDATE_TYPE
}